var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"name":"top","id":"top"}},[_c('span',{staticClass:"sr-only"},[_vm._v("top")])])
}]

export { render, staticRenderFns }